import React from 'react';
import './PopUp.scss';
import { connect } from 'react-redux';
import DropdownWithFadeBox from 'Flow2/components/Article/Utilities/DropdownWithFadeBox/DropdownWithFadeBox';
import DateBox from 'Flow2/components/Article/Utilities/DateBox/DateBox';
import TextArea from 'Flow2/components/Article/Utilities/TextArea/TextArea';
import DateGroup from 'Flow2/components/Article/Utilities/DateGroup/DateGroup';
import CheckBox from 'Flow2/components/Article/Utilities/CheckBox/CheckBox';
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { faQuestion, faExclamation, faImage, faTimesCircle, faBook, faSignal } from '@fortawesome/free-solid-svg-icons';
import { modules, formats } from 'Flow2/components/Article/Helpers/EditorHelper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

class PopUp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            popUpObjects: {}
        }
    }

    isRequired = (item) => (this.props.requiredObj && this.props.requiredObj[item.name]);
    isInfo = () => this.props.popUpType && this.props.popUpType === ArticleTypes.INFOTYPE;
    isPreview = () => this.props.popUpType && this.props.popUpType === ArticleTypes.PREVIEWTYPE;
    isHistory = () => this.props.popUpType && this.props.popUpType === ArticleTypes.HISTORYTYPE;
    isModal = () => this.props.popUpType && this.props.popUpType === ArticleTypes.MODALTYPE;
    isStatistic = () => this.props.popUpType && this.props.popUpType === ArticleTypes.STATISTICTYPE;
    isMailing = () => this.props.popUpType && this.props.popUpType === ArticleTypes.MAILINGTYPE;

    showCloseIcon = () => {
        return (
            <div className="custom-close-icon" onClick={this.closePopUp("preview")}>
                <FontAwesomeIcon icon={faTimesCircle} />
            </div>)
    }

    getPopUpMainClasses = () => {
        if (this.isInfo()) return "custom-sm-popup";
        if (this.isPreview()) return "custom-popup-left";
        if (this.isHistory()) return "custom-popup-history";
        if (this.isStatistic()) return "custom-popup-statistic";
        if (this.isMailing()) return "custom-popup-mailing";
        if (this.isModal()) return "custom-popup-modal";
        return "custom-popup";
    }

    getPopUpIcon = () => {
        let icon;
        let classes = this.isModal() ? "custom-header-icon-sm" : "custom-header-icon";
        switch (this.props.popUpType) {
            case ArticleTypes.INFOTYPE:
                icon = faExclamation;
                break;
            case ArticleTypes.QUESTIONTYPE:
                icon = faQuestion;
                break;
            case ArticleTypes.PREVIEWTYPE:
                icon = faImage;
                break;
            case ArticleTypes.HISTORYTYPE:
                icon = faBook;
                break;
            case ArticleTypes.STATISTICTYPE:
            case ArticleTypes.MODALTYPE:
                icon = this.props.customIcon ? this.props.customIcon : faSignal;
                break;
            default:
                icon = null;
                break;
        }

        if (icon) return (
            <div className={classes}>
                <FontAwesomeIcon icon={icon} />
            </div>
        )
        return (<div />)
    }

    onDDItemClick = (name, id, value) => {
        StoreHelper.checkAndUpdateDataObj({
            updateDataObjects: this.props.updatePopUpObjects,
            mainObj: this.props.mainObj, subObjName: this.props.subObjName,
            name: name, value: value
        });
    }

    onPopUpChange = (e) => {
        const { name, value } = e.target;
        const { popUpObjects } = this.state;
        this.setState({ popUpObjects: { ...popUpObjects, [`${name}`]: value } });
        StoreHelper.checkAndUpdateDataObj({
            updateDataObjects: this.props.updatePopUpObjects,
            mainObj: this.props.mainObj, subObjName: this.props.subObjName,
            name: name, value: value
        });
    }

    onEditorChange = (name, e) => {
        const { popUpObjects } = this.state;
        this.setState({ popUpObjects: { ...popUpObjects, [`${name}`]: e } });
        StoreHelper.checkAndUpdateDataObj({
            updateDataObjects: this.props.updatePopUpObjects,
            mainObj: this.props.mainObj, subObjName: this.props.subObjName,
            name: name, value: e
        });
    }

    closePopUp = (name) => () => {
        if (this.props.onlyTest && this.props.cancelCallback) {
            return this.props.cancelCallback()
        }

        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { showOverlay: false }
        });

        if (this.props.cancelCallback) this.props.cancelCallback();
    }

    confirmPopUp = (name) => () => {
        if (this.props.confirmCallback) this.props.confirmCallback();
    }

    showEditor = ({ item }) => {
        return (
            <div className="custom-editor">
                <ReactQuill theme="snow" onChange={this.onEditorChange.bind(this, item.name)} onBlur={this.onFieldBlur}
                    modules={modules} formats={formats} value={this.state.popUpObjects[item.name] || ''} name={item.name} />
            </div>)
    }

    showDropDown = ({ item, isSingle }) => {
        return (
            <DropdownWithFadeBox item={item} lg={this.props.lg} mainObj={this.props.mainObj} current={item.current}
                mainObjName={this.props.mainObjName} subObjName={this.props.subObjName} listType={item.type}
                updateDataObjects={this.props.updatePopUpObjects} isSingle={isSingle} isRequired={this.isRequired(item)} />
        )
    }

    showCheckBox = ({ item }) => {
        return (
            <CheckBox item={item} lg={this.props.lg} mainObj={this.props.mainObj}
                mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
                updateDataObjects={this.props.updatePopUpObjects} isRequired={this.isRequired(item)} />
        )
    }

    showDateBox = ({ item }) => {
        return (
            <DateBox item={item} lg={this.props.lg} mainObj={this.props.mainObj}
                mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
                updateDataObjects={this.props.updatePopUpObjects} isRequired={this.isRequired(item)} />
        )
    }

    showDateGroup = ({ item }) => {
        return (
            <DateGroup item={item} lg={this.props.lg} mainObj={this.props.mainObj}
                datePosFirst={item.datePosFirst} datePosSecond={item.datePosSecond}
                current={item.current}
                mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
                updateDataObjects={this.props.updatePopUpObjects} isRequired={this.isRequired(item)} />
        )
    }

    showInput = ({ item }) => {
        let inputClasses = (this.props.requiredObj && this.props.requiredObj[item.name])
            ? "custom-group-required" : "custom-group";
        return (
            <div className={inputClasses}>
                <div className="custom-mr20">{this.props.intl.formatMessage({ id: item.intl })}</div>
                <input type="text" name={item.name} value={this.state.popUpObjects[`${item.name}`]}
                    onChange={this.onPopUpChange} />
            </div>
        )
    }

    showTextArea = ({ item }) => {
        return <TextArea item={item} lg={this.props.lg} mainObj={this.props.mainObj} key={`key${item.name}`}
            mainObjName={this.props.mainObjName} subObjName={this.props.subObjName} listType={item.type}
            updateDataObjects={this.props.updatePopUpObjects} isRequired={this.isRequired(item)} />
    }

    showText = ({ item }) => {
        return (
            <div className="custom-group">
                <p className="custom-text">{item.intl}</p>
            </div>
        )
    }

    getBtnClasses = (item) => {
        if (this.isInfo()) return "custom-sm-btn custom-btn-active";
        if (item && item.htmlclass) return `custom-btn ${item.htmlclass}`;
        return "custom-btn";
    }

    getBodyClasses = () => {
        if (this.isInfo()) return "custom-body-lg custom-mt10";
        if (this.props.isSmall) return "custom-body-sm custom-mt10";
        return "custom-body custom-mt10";
    }

    showPopUpHeader = () => {
        return (
            <div className="custom-header">
                {this.isPreview() && this.showCloseIcon()}
                {this.isHistory() && this.showCloseIcon()}
                {this.isStatistic() && this.showCloseIcon()}
                {this.isModal() && this.showCloseIcon()}
                {this.isMailing() && this.showCloseIcon()}
                {this.getPopUpIcon()}
                <div>{this.props.intl.formatMessage({ id: this.props.titleIntl })}</div>
            </div>)
    }

    showPopUpBody = () => {
        let bodyItems = this.props.contentItems || [];
        if ((this.isHistory() || this.isModal()) && this.props.children) return this.props.children;
        if (bodyItems.length && !this.isInfo())
            return (
                <div className={this.getBodyClasses()}>
                    {
                        bodyItems.map(item => {
                            if (item.type && item.type === ArticleTypes.DROPDOWN) return this.showDropDown({ item, isSingle: true });
                            if (item.type && (item.type === ArticleTypes.LIST || item.type === ArticleTypes.USERLIST
                                || item.type === ArticleTypes.COUNTRYLIST)) {
                                return this.showDropDown({ item, isSingle: false });
                            }
                            if (item.type && item.type === ArticleTypes.INPUT) return this.showInput({ item });
                            if (item.type && item.type === ArticleTypes.TEXT) return this.showText({ item });
                            if (item.type && item.type === ArticleTypes.TEXTAREA) return this.showTextArea({ item });
                            if (item.type && item.type === ArticleTypes.DATEBOX) return this.showDateBox({ item });
                            if (item.type && item.type === ArticleTypes.DATEGROUP) return this.showDateGroup({ item });
                            if (item.type && item.type === ArticleTypes.CHECKBOX) return this.showCheckBox({ item });
                            if (item.type && item.type === ArticleTypes.EDITOR) return this.showEditor({ item });
                        })
                    }
                    {this.isStatistic() && this.props.children}
                </div>)

        if (this.props.children) return this.props.children;
        return null;
    }

    showPopUpFooter = () => {
        if (this.isHistory() || this.isStatistic() || this.isModal()) return (<div></div>)
        let footerBtnItems;
        if (this.isInfo()) footerBtnItems = ArticleTypes.POPUP_INFO_ITEMS;
        else footerBtnItems = this.props.confirmBtnItems || ArticleTypes.POPUP_BTN_ITEMS;

        let boxClasses = ((footerBtnItems && footerBtnItems.length == 1) || this.isInfo())
            ? "custom-sm-btnbox custom-mt10" : "custom-btnbox custom-mt20";
        return (
            <div className={boxClasses}>
                {footerBtnItems.map(item => (
                    <div className={this.getBtnClasses(item)} onClick={this[item.onClick](item.name)}>
                        <span className="custom-mr5">{this.props.intl.formatMessage({ id: item.intl })}</span>
                        <FontAwesomeIcon icon={item.icon} />
                    </div>
                ))}
            </div>)
    }

    render() {
        return (
            <div className="PopUp" onClick={PageHelper.onPopUpClick}>
                {this.props.mainObj[`${this.props.subObjName}`].showOverlay ?
                    <div className={this.props.isSmall ? "custom-sm-overlay" : "custom-overlay"}>
                        <div className={this.getPopUpMainClasses()}>
                            {this.showPopUpHeader()}
                            {this.showPopUpBody()}
                            {this.showPopUpFooter()}
                        </div>
                    </div> : null}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    lg: state.ui.language,
})
const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(PopUp));